<template>
  <div class="gallery">
    <div class="container">
      <div class="heading mb-4" data-aos="fade-down">
        <h2 class="title font-secondary fs-40 text-teal-dark text-center">Gallery</h2>
      </div>

      <div class="row justify-content-center">
        <div class="col-12 col-sm-6 mb-3">
          <iframe width="100%" height="285" src="https://www.youtube.com/embed/RaR0UNEBr5w" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <iframe width="100%" height="285" src="https://www.youtube.com/embed/ZZmhU33yYdw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div class="row justify-content-center">
        <div
          v-for="(images, index) in gallery"
          :data-key="index"
          :data-count="images.items.length - 1"
          :key="index"
          :class="images.className"
        >
          <div class="flex-wrap row d-flex justify-content-center">
            <div
              v-for="(image, imageIndex) in images.items"
              :key="imageIndex"
              :class="image.class"
            >
              <div class="elevation" :data-aos="image.transition">
                <div class="gallery-item" @click="showPopup(image)">
                  <!-- <v-lazy-image :src=""/> -->
                  <img :src="`${image.th || image.full}&tr=w-600`">
                  <div class="hover-content">
                    <i class="material-icons">zoom_in</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row justify-content-center d-md-flex d-none"> -->
        <!-- <div class="col-md-12 col-lg-10 col-xl-8"> -->
          <!-- <iframe width="100%" height="400" src="https://www.youtube.com/embed/rTU7Zv1OiUw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
        <!-- </div> -->
      <!-- </div> -->
    </div>

    <transition name="fade">
      <div class="popup" v-if="preview">
        <div class="popup-wrapper">
          <div class="popup-tools">
            <button class="popup-close" @click="closePopup">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="popup-controls">
            <div class="left control" @click="prev">
              <i class="material-icons">chevron_left</i>
            </div>
            <div class="right control" @click="next">
              <i class="material-icons">chevron_right</i>
            </div>
          </div>
          <div class="popup-body">
            <img :src="`${preview.full}&tr=w-1024`" class="img-fluid"/>
            <div class="copyright" v-if="preview.copyright">
              <i class="material-icons">camera_alt</i> Taken by <a :href="preview.copyright.link || null">{{ preview.copyright.name }}</a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      slickOpt: {
        slideToShow: 1
      },
      gallery: [
        {
          className: 'col-12',
          items: [
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4802.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645883066327',
              transition: "fade-down-right",
              class: "col-12 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4801.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882930513',
              transition: "fade-down-right",
              class: "col-6 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4799.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882211947',
              transition: "fade-down-right",
              class: "col-6 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4796.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882210511',
              transition: "fade-down-right",
              class: "col-12 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4793.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882209746',
              transition: "fade-down-right",
              class: "col-6 col-md-4",
            },


            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4810.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882215196',
              transition: "fade-down-right",
              class: "col-6 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4809.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882214585',
              transition: "fade-down-right",
              class: "col-12 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4811.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882215648',
              transition: "fade-down-right",
              class: "col-6 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4812.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882215892',
              transition: "fade-down-right",
              class: "col-6 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4754.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882208731',
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-md-11",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4756.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882209292',
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-12",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4797.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882210982',
              transition: "fade-down-right",
              class: "col-12 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4798.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882211461',
              transition: "fade-down-right",
              class: "col-6 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4808_1_.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882214145',
              transition: "fade-down-right",
              class: "col-6 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4751.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882207447',
              transition: "fade-down-right",
              class: "col-6 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4750.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882207235',
              transition: "fade-down-right",
              class: "col-6 col-md-4",
            },
            {
              full: 'https://ik.imagekit.io/crk/adek-suja/IMG_4743.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1645882207101',
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-md-11",
            },
          ],
        },
      ],
      preview: null
    };
  },
  mounted() {
    document.addEventListener("keydown", e => {
      if (this.preview) {
        if (e.key === "ArrowRight") {
          this.next();
        }
        if (e.key === "ArrowLeft") {
          this.prev();
        }
        if (e.key === "Escape") {
          this.closePopup();
        }
      }
    });
  },
  methods: {
    showPopup(image) {
      this.preview = image;
    },
    closePopup() {
      this.preview = null;
    },
    next() {
      this.preview = this.nextImage;
    },
    prev() {
      this.preview = this.prevImage;
    }
  },
  computed: {
    images() {
      const images = [];

      this.gallery.forEach(items => {
        images.push(...items.items);
      });

      return images;
    },
    currentIndex() {
      return this.preview.full
        ? this.images.map(item => item.full).indexOf(this.preview.full)
        : null;
    },
    nextImage() {
      let index = this.currentIndex + 1;
      if (index > this.images.length - 1) {
        index = 0;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
    prevImage() {
      let index = this.currentIndex - 1;
      if (index < 0) {
        index = this.images.length - 1;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    }
  },
  watch: {
    preview() {
      if(this.preview === null) {
        document.querySelector('body').style.overflowY = null;
      } else {
        document.querySelector('body').style.overflowY = 'hidden';
      }
    }
  }
};
</script>

<style type="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.w-100i {
  width: 100% !important;
  max-width: 100% !important;
  flex: 0 0 100% !important;
}
</style>
